import React from 'react';
import PropTypes from 'prop-types';
import { clickTracker } from '../../lib/common';
import styles from './EcsPortal.module.scss';

export default function PaymentChequeDisclaimer({ setShowTicketCreate }) {
  const listItems = [
    'Visibility to over 25 crore ready to buy customers using Justdial',
    'Digital presence of your business on search engines',
    '10x more visibility than a company that is not paying Justdial',
    'Justdial Verified Stamp and reviews & ratings to help you earn the trust of customers',
  ];
  return (
    <div>
      <>
        <div className="font12 fw600 color111 mt-12">Stopping your cheque will lead to an inactive contract</div>

        <ul className={`${styles.Accordion__DotItems} mt-15`}>
          {listItems.map((each, idx) => (
            <li className={`${styles.Accordion__DotItem}`} key={idx}>
              <span className={`${styles.Accordion__DotItem__Circle} mr-10`} />
              <span className={`${styles.Accordion__DotItem__Text} font12 fw400 color111`}>{each}</span>
            </li>
          ))}
        </ul>
      </>
      <div className={`${styles.Accordion__Contant__Btnbox}`}>
        <button
          type="button"
          className={`${styles.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF mt-20`}
          style={{
            backgroundColor: '#0076d7',
            border: '1px solid #0076d7',
            transitionProperty: 'background-color, background-image, border-color, box-shadow',
            transition: 'all 0.8s',
            color: '#fff',
          }}
          onClick={async () => {
            await clickTracker('FAQ_stopcheque_stop', 'payments_FAQ_stopcheque');
            setShowTicketCreate(true);
          }}
        >
          Stop cheque
        </button>
      </div>
    </div>
  );
}

PaymentChequeDisclaimer.propTypes = {
  setShowTicketCreate: PropTypes.func,
};
